module.exports = __webpack_public_path__ + "static/media/LouisDeWeaver.040c3034.jpeg";